/**
 * Claves de sesión en localStorage. Un solo lugar para limpiar al logout
 * o al cambiar de usuario (PC compartida, mismo perfil de SO).
 */
export const CLIENT_AUTH_STORAGE_KEYS = [
  'token',
  'refreshToken',
  'tokenExpiresAt',
  'user',
  'accessibleCenters',
  'accessibleApps',
  'currentCenterId',
  'currentAppId',
  'username',
] as const;

export interface StoredAuthTokens {
  accessToken: string | null;
  refreshToken: string | null;
  expiresAt: Date | null;
}

export interface WriteAuthTokensInput {
  token: string;
  refreshToken?: string;
  expiresIn?: number;
}

export function readAuthTokens(): StoredAuthTokens {
  const accessToken = localStorage.getItem('token');
  const refreshToken = localStorage.getItem('refreshToken');
  const expiresRaw = localStorage.getItem('tokenExpiresAt');
  let expiresAt: Date | null = null;
  if (expiresRaw) {
    const parsed = new Date(expiresRaw);
    if (!Number.isNaN(parsed.getTime())) {
      expiresAt = parsed;
    }
  }
  return { accessToken, refreshToken, expiresAt };
}

export function writeAuthTokens({ token, refreshToken, expiresIn }: WriteAuthTokensInput): void {
  localStorage.setItem('token', token);
  if (refreshToken) {
    localStorage.setItem('refreshToken', refreshToken);
  }
  if (expiresIn != null && expiresIn > 0) {
    const expiresAt = new Date(Date.now() + expiresIn * 1000);
    localStorage.setItem('tokenExpiresAt', expiresAt.toISOString());
  }
}

export function clearClientAuthStorage(): void {
  for (const key of CLIENT_AUTH_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
  window.dispatchEvent(new CustomEvent('incer-client-auth-cleared'));
}
